export interface DeviceConfiguration {
  deviceConfigurationId: string;
  deviceId: string;
  deviceName: string;
  deviceDescription: string;
  installedProduct: string;
  installedVersion: string;
  releaseType: string;
  licenseKey?: string;
  status: string;
  releaseChannel: string;
  tenantCode: string;
  label: string;
  licensePackageId?: string;
  webWizardConfig?: string;
  // clientConfig: string;
}

// "deviceConfigurationId": "09a92089-c55b-4aca-a0a4-e4bfabf3bc69",
//   "deviceId": "sy/x+CFONceERW83n+sbaw==",
//   "deviceName": "TEST-DEVICE-NAME",
//   "deviceDescription": "TEST-DEVICE-DESCRIPTION",
//   "installedProduct": "enterprise",
//   "installedVersion": "6.0.0.0",
//   "releaseType": "EXE",
//   "releaseChannel": "Latest",
//   "tenantCode": "REM-MAG-ROOM",
//   "label": "Mago",
//   "licenseKey": "VP-REMGO-INTER-DEMO1-23456",
//   "status": "WebWizardLicenseActivated",
//   "licensePackageId": "25f0b393-d765-4605-b6ab-6bba97daadd3",
//   "webWizardConfig": null,
//   "clientConfig": {
//   "monitors": [
//     {
//       "name": "Monitor 1"
//     },
//     {
//       "name": "Monitor 2"
//     }
//   ]
// }

export const DeviceConfigurationDeserializer = (
  /* eslint-disable-next-line  @typescript-eslint/explicit-module-boundary-types */
  input: any
): DeviceConfiguration => {
  return {
    deviceConfigurationId: input.deviceConfigurationId || "",
    deviceId: input.deviceId || "",
    deviceName: input.deviceName || "",
    deviceDescription: input.deviceDescription || "",
    installedProduct: input.installedProduct || "",
    installedVersion: input.installedVersion || "",
    releaseType: input.releaseType || "",
    licenseKey: input.licenseKey,
    status: input.status || "",
    releaseChannel: input.releaseChannel || "",
    tenantCode: input.tenantCode || "",
    label: input.label || "",
    licensePackageId: input.licensePackageId,
    webWizardConfig: input.webWizardConfig,
    // clientConfig: string;
  };
};

export interface DeviceUpdates {
  latestVersion: string;
  fileHash: string;
  downloadUrl: string;
}

/* eslint-disable-next-line  @typescript-eslint/explicit-module-boundary-types */
export const DeviceUpdatesDeserializer = (input: any): DeviceUpdates => {
  return {
    latestVersion: input.latestVersion || "",
    fileHash: input.fileHash || "",
    downloadUrl: input.downloadUrl || "",
  };
};
